import { inject, Injectable, Type } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { AlarisDialogService } from '@campaign-portal/components-library';
import { LostDataDialogComponent, CanDeactivateComponent } from './';
import { CanDeactivateFn } from '@angular/router';
import { DialogRef } from '@angular/cdk/dialog';

@Injectable({
	providedIn: 'root',
})
export class CanDeactivateGuardService {
	private lostDataDialogRef: DialogRef<boolean, unknown> | null = null;

	constructor(public readonly dialog: AlarisDialogService) {}

	canDeactivate(component: CanDeactivateComponent): Observable<boolean> {
		if (component.canDeactivate()) {
			return of(true);
		}
		return this.lostDataDialog();
	}

	lostDataDialog(component?: Type<unknown>): Observable<boolean> {
		const dialogRef = this.dialog.open<boolean>(component ?? LostDataDialogComponent, { disableClose: false });
		this.lostDataDialogRef = dialogRef;
		return dialogRef.closed.pipe(map(Boolean));
	}

	closeLostDataDialog(): void {
		this.lostDataDialogRef?.close();
	}
}

export const CanDeactivateGuard: CanDeactivateFn<CanDeactivateComponent> = (
	component: CanDeactivateComponent
): Observable<boolean> | boolean => inject(CanDeactivateGuardService).canDeactivate(component);
